import React, { useReducer, createContext, useContext } from 'react'
import reducer from './reducer'

export const AppContext = createContext({})

export const initialState = {
    searchKey: '',
    sortBy: '',
    sortOrder: '',
    assignedToMe: false,
    page: 1,
}

export const PageContextProvider = ({ children }) => (
    <AppContext.Provider value={useReducer(reducer, initialState)}>
        {children}
    </AppContext.Provider>
)

export const withAppState = (Component) => {
    return function WrapperComponent(props) {
        const [appState] = usePageContext()
        return <Component {...props} appState={appState} />
    }
}

export const usePageContext = () => useContext(AppContext)
